<template>
  <div>
    <ListagemMenuXPerfilComponent />
  </div>
  
</template>

<script>

import ListagemMenuXPerfilComponent from '../components/abas/ListagemMenuXPerfilComponent.vue';

export default {
  components: { 
    ListagemMenuXPerfilComponent
  },
  name: "MenuXPerfilPage",

  
};
</script>
